import { ReportService } from "./report-api";
import { autoinject } from "aurelia-framework";
import { IReportTemplateAM } from "./models/report-template";
import { Router } from "aurelia-router";

@autoinject
export class ReportDelete {
	template: IReportTemplateAM;
	backButtonTitle: string;
	deleteTemplateName: string;

	get deleteAllowed(): boolean {
		return this.template.isPrivate || this.deleteTemplateName === this.template.name;
	}
	
	constructor(private api: ReportService, private router: Router) {
	}

	async activate(urlParams: any) {
		this.template = await this.api.getReportTemplate(urlParams.reportId);
	}	

	created() {
		this.backButtonTitle = this.router.currentInstruction.config.settings.backButtonResource;
	}

	async deleteReport() {
		await this.api.deleteReportTemplate(this.template);
		this.router.navigateToRoute('report-list');
	}

	goBack() {
		this.router.navigateBack();
	}
}
